// if (window.innerWidth < 768) {
var searchIcon = document.querySelector(
  '.header_wrap .header__wrapper .header__secondary-nav [aria-controls="search-drawer"]'
);
var searchInput =
  window.innerWidth < 768
    ? document.querySelector(
        "#search_mini_form .wizzy-search-form .wizzy-search-input"
      )
    : document.querySelector("search-drawer .search-input input");

searchIcon.addEventListener("click", () => {
  setTimeout(() => {
    if (window.innerWidth < 768) {
      document.querySelector(".search-drawer-close").click();
    }
    // console.log(searchInput);
    searchInput?.click();
  }, 500);
});

var cart = document.querySelector("cart-drawer.cart-drawer");

if (cart) {
  cart.addEventListener("click", () => {
    var searchInputMobile = document.querySelector(
      "body.wizzyMobileTapped #searchInput"
    );

    searchInputMobile?.click();
  });
}

if (window.innerWidth > 768) {
  let searchDrawer = document.querySelector(".search-drawer");
  let autoCompleteWrapperBody = document.querySelector(
    ".wizzy-body-end-wrapper"
  );

  if (autoCompleteWrapperBody) {
    autoCompleteWrapperBody.addEventListener("click", () => {
      let autoCompleteWrapper = autoCompleteWrapperBody.querySelector(
        ".wizzy-autocomplete-wrapper"
      );
      if (autoCompleteWrapper) {
        autoCompleteWrapper.style.display = "none";
      }
      // if (searchDrawer.hasAttribute("open")) {
      //   searchDrawer.setAttribute("open", "");
      // }
    });
  }
}
// }

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      data.filters.configs.layout = "v2";
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      return data;
    }
  );

  function removeExpiredProducts(products) {
    expiriedProducts = [];
    removeProductIndex = [];
    products.forEach((product, index) => {
      attributes = product.attributes;
      if(attributes) {
        attributes.forEach(atr => {
          if(atr.id === "product_expiry_date_custom") {
            expiryDate = new Date(atr.values[0].value[0].replace(' ', 'T'));
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if(expiryDate < today) {
              removeProductIndex.push(index);
            }
          }
        });
      }
    });
    expiriedProducts = products.filter((_, index) => !removeProductIndex.includes(index));
    return expiriedProducts;
  }

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (payload) {
      try {
        
        products = [];
        if(payload.api === "search" || payload.api === "filter") {
          products = payload.response.payload.result;
          if(products) {
            expiriedProducts = removeExpiredProducts(products);
            payload.response.payload.result = expiriedProducts;
            payload.response.payload.total = expiriedProducts.length;
          }
        } else if(payload.api === "autocomplete") {
          products = payload.response.payload?.products?.result;
          
          if(products) {
            expiriedProducts = removeExpiredProducts(products);
            payload.response.payload.products.result = expiriedProducts;
          }
        }
      } catch (error) {
        console.log(error);
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      data.forEach((item) => {
        item.sellingPrice = item.sellingPrice.split(".")[0];
        item.price = item.price.split(".")[0];
        item.discount = item.discount.split(".")[0];

        item.attributes.forEach((atr) => {
          // var minValueObject;
          if (atr.id == "product_handle") {
            item.productHandle = atr.values[0].value[0];
          } else if (atr.id === "product_vendor") {
            item.vendor = atr.values[0].value[0];
          } else if (atr.id == "product_badge_judgeme") {
            item.badge_judgeme = atr.values[0].value[0];

            const htmlString = atr.values[0].value[0],
              tempElement = document.createElement("div");
            tempElement.innerHTML = htmlString;
            const dataScore = tempElement
              .querySelector(".jdgm-prev-badge__stars")
              .getAttribute("data-score");
            const dataReview = tempElement
              .querySelector(".jdgm-prev-badge")
              .getAttribute("data-number-of-reviews");
            item.totalRatings = dataScore;
            item.totalReview = dataReview;
          } else if (atr.id == "product_offer_custom") {
            item.offerCustom = atr.values[0].value[0];
          } else if (atr.id == "product_bau_price_custom") {
            item.bauPrice = atr.values[0].value[0];
          } else if (atr.id == "product_subtitle_custom") {
            item.subTitle = atr.values[0].value[0];
          } else if (atr.id == "product_product_main_title_custom") {
            item.mainTitle = atr.values[0].value[0];
          } else if (
            atr.id == "product_food_type_my_fields" &&
            atr.values[0].value[0] == "Vegetarian "
          ) {
            item.isFoodTypeIsVeg = true;
          } else if (
            atr.id == "product_food_type_my_fields" &&
            atr.values[0].value[0] == "NA"
          ) {
            item.isFoodTypeIsNA = true;
          }else if (
            atr.id == "product_food_type_my_fields" &&
            atr.values[0].value[0] == ""
          ) {
            item.isFoodTypeIsNA = true;
          } else if (atr.id == "product_variant_prices") {
            // if (atr.values.length > 1) {
            //   item.hasVariantPrice = true;
            //   const minValueObject = atr.values.sort(
            //     (a, b) => a.value[0] - b.value[0]
            //   )[0];
            //   item.sellingPrice = minValueObject.value[0];
            // }
          } else if (atr.id == "product_variant_compare_at_prices") {
            // console.log(minValueObject);
          }
        });
      });
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      const prohibitedWords = [
        "bitch",
        "bloody",
        "crap",
        "1=1; drop table note",
        "shit",
        "dog",
        "cat",
        "rat",
      ];
      if (payload && prohibitedWords.includes(payload.q.toLowerCase())) {
        payload.q = "abcdefghija";
      }
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      const prohibitedWords = [
        "bitch",
        "bloody",
        "crap",
        "1=1; drop table note",
        "shit",
        "dog",
        "cat",
        "rat",
      ];
      if (
        payload.api === "search" &&
        payload.response &&
        payload.response.payload.filters
      ) {
        const filterQuery = payload.response.payload.filters.q.toLowerCase();
        prohibitedWords.includes(filterQuery) && (payload.error = !0);
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      if (window.innerWidth < 768) {
        var searchform = document.querySelector(
          ".wizzy-search-form-wrapper.mf-initial "
        );
        var backBtn = document.querySelector(
          ".wizzy-search-form .wizzy-search-back"
        );
        if (searchform && searchform.classList.contains("mobileTapped")) {
          backBtn.click();
          // searchform.classList.remove("mobileTapped");
        }
      } else {
        var closeBtn = document.querySelector(
          ".search-drawer .search-drawer-close"
        );
        if (closeBtn) {
          closeBtn.click();
        }
      }
      var header = document.querySelector(
        ".shopify-section-group-header-group .header_wrap .header"
      );
      if (header && header.hasAttribute("allow-transparency")) {
        header.removeAttribute("allow-transparency");
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (payload) {
      // console.log("VIEW_RENDER");
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      // console.log("PRODUCTS_CACHED_RESULTS_RENDERED");
      return data;
    }
  );

  changeTemplate("wizzy-autocomplete-topproducts");
  changeTemplate("wizzy-search-wrapper");
  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-common-select");
  changeTemplate("wizzy-autocomplete-suggestions");
};
const changeTemplate = function (div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;
  oldDiv.text = newDiv;
};
